module.exports = __webpack_public_path__ + "img/image76.a65aa14.webp";